import { GiBroom } from "react-icons/gi";
import { BiShuffle } from "react-icons/bi";
import { FaDownload } from "react-icons/fa";
import React, { useState } from 'react';
import { Tabs, Select, Button, Switch, Menu, Dropdown } from 'antd';
import { Form, InputGroup, FormControl, Container, Row, Col, ButtonGroup, Badge } from 'react-bootstrap';
import { FaUndo, FaRedo, FaExchangeAlt, FaCrosshairs, FaBold, FaItalic, FaUnderline, FaTimes, FaArrowLeft, FaArrowRight, FaMinus, FaPlus } from 'react-icons/fa';
import { set } from "react-hook-form";

const { TabPane } = Tabs;
const { Option } = Select;

const SettingsPanel = ({ setIsTextClicked, setKonvaImage, KonvaImage,isTextClicked,
  widthInInches, setWidthInInches, heightInInches, setHeightInInche,isRulerChecked, setIsRulerChecked,
  isShowGridChecked, setIsShowGridChecked,setLink, link,onCodeTypeChange,
  isSnapToGridChecked, setIsSnapToGridChecked,textFormatting,setTextFormatting,fontSize, setFontSize ,setTextColor, textColor, handleSaveAsPDF   }) => {
  const [activeTab, setActiveTab] = useState('label');
  const [multipleQR, setMultipleQR] = useState(false);
  const [labelCopies, setLabelCopies] = useState(1); // State for label copies
  const [isImageClicked, setIsImageClicked] = useState(false); // State to track image button click

  const colors = ["#000000", "#808080", "#FF0000", "#FFFF00", "#008000", "#0000FF", "#800080", "#008000",];
  const shapes = ['Square', 'Rounded', 'Circle', 'Barbell'];
  const colorMenu = (
    <Menu>
      <Menu.Item>
        <div style={{ display: "flex", gap: "5px", padding: "5px", flexWrap: "wrap" }}>
          {colors.map((color, index) => (
            <div
              key={index}
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: color,
                border: "1px solid #ccc",
                cursor: "pointer",
              }}
              onClick={() => handleColorChange(color)} // ✅ Pass color
            />
          ))}
        </div>
      </Menu.Item>
    </Menu>
  );

  const shapeMenu = (
    <Menu>
      {shapes.map((shape, index) => (
        <Menu.Item key={index}>
          {shape}
        </Menu.Item>
      ))}
    </Menu>
  );
   const handleColorChange = (color) => {
    if (setTextColor) {
      setTextColor(color); // ✅ Update text color state
    } else {
      console.error("setTextColor is undefined!");
    }
  };
  const updateTextFormatting = (newStyle) => {
    setTextFormatting((prev) => ({
      ...prev,
      ...Object.keys(newStyle).reduce((acc, key) => {
        if (key === "fontWeight") {
          acc[key] = prev[key] === "bold" ? "Arial" : "bold"; // ✅ Toggle between "bold" and "normal"
        } else {
          acc[key] = prev[key] === newStyle[key] ? undefined : newStyle[key]; // Toggle other styles
        }
        return acc;
      }, {}),
    }));
  };
  
  
  
  const getSaveButtonText = () => {
    return activeTab === 'print' ? 'Apply' : 'Save & Next';
  };

  // // Function to change the tab when clicking "Go Back" or "Save & Next"
  // const handleTabChange = (direction) => {
  //   const tabs = ['label', 'design', 'data', 'print'];
  //   const currentIndex = tabs.indexOf(activeTab);

  //   if (direction === 'next') {
  //     if (currentIndex < tabs.length - 1) {
  //       setActiveTab(tabs[currentIndex + 1]);
  //     }
  //   } else if (direction === 'back') {
  //     if (currentIndex > 0) {
  //       setActiveTab(tabs[currentIndex - 1]);
  //     }
  //   }
  // };

  // Functions to handle label copies increment/decrement
  const handleIncrement = () => {
    setLabelCopies((prev) => prev + 1);
  };

  const handleDecrement = () => {
    setLabelCopies((prev) => (prev > 1 ? prev - 1 : 1));
  };
  const handleTextButtonClick = () => {
    //make it toggle the text click state
    setIsTextClicked((prev) => !prev); // Toggle the text click state
  };
  const handleImageButtonClick = () => {
    //make it toggle the text click state
    setIsImageClicked((prev) => !prev); // Toggle the text click state
    setKonvaImage(null); // Reset selected image when switching to image button
  };
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const img = new window.Image();
        img.src = reader.result;
        img.onload = () => {
          setKonvaImage({
            image: img,
            x: 50, // Initial position
            y: 50,
            width: 200,
            height: 200,
            rotation: 0,
          });
        };
      };
      reader.readAsDataURL(file);
    }
  };
  const handleTabChange = async (direction) => {
    debugger;
    const tabs = ['label', 'design', 'data', 'print'];
    const currentIndex = tabs.indexOf(activeTab);

    // Function to convert image to Base64
    const getBase64Image = (image) => {
        return new Promise((resolve, reject) => {
            if (!image) return resolve(null); // Handle null images

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Set canvas size to match image
            canvas.width = image.width;
            canvas.height = image.height;

            ctx.drawImage(image, 0, 0);
            const dataUrl = canvas.toDataURL('image/png'); // Convert to Base64
            resolve(dataUrl);
        });
    };

    if (direction === 'next') {
        const base64Image = KonvaImage?.image ? await getBase64Image(KonvaImage.image) : null;

        // Save data as JSON when moving to the next step
        const formData = {
            label: {
                widthInInches: parseFloat(widthInInches) || 0,
                heightInInches: parseFloat(heightInInches) || 0,
                isRulerChecked,
                isShowGridChecked,
                isSnapToGridChecked,
                textColor: textColor, // ✅ Store selected color
              
            },
            design: {
                isTextClicked, // ✅ Store the actual value
                konvaImage: {
                    ...KonvaImage, // Keep existing properties
                    image: base64Image, // ✅ Store Base64 version of the image
                },
                fontSize: fontSize || 16, // ✅ Store font size
                textFormatting, // ✅ Store text formatting state
            },
            data: {
                link: '', // Placeholder for link data
                qrStart: '', // Placeholder for QR start value    
                qrEnd: '', // Placeholder for QR end value
                multipleQR,
                labelCopies,
            },
            print: {
                labelCopies,
            },
        };

        console.log("Saved Data:", JSON.stringify(formData, null, 2)); // Logs JSON to console

        if (currentIndex < tabs.length - 1) {
            setActiveTab(tabs[currentIndex + 1]);
        }
    } else if (direction === 'back') {
        if (currentIndex > 0) {
            setActiveTab(tabs[currentIndex - 1]);
        }
    }
};
const handleClearButtonClick = () => {
  debugger;

  // Reset image and text related states
  setKonvaImage(null);           // Clear selected image
  if (KonvaImage) {
    setKonvaImage({ ...KonvaImage, image: null });
  }
    
  setIsImageClicked(false);      // Reset image button clicked
  setIsTextClicked(false);       // Reset text button clicked

  // Reset label settings
  setLabelCopies(1);             // Reset number of label copies

  // Reset formatting
  setTextFormatting({});         // Reset text formatting
  setTextColor("#000000");       // Default text color
  setFontSize(16);               // Default font size

  // Reset canvas dimensions
  setWidthInInches(6);           // Example default width
  setHeightInInche(5);           // Example default height

  // Reset toggles
  setIsRulerChecked(true);      // Hide ruler
  setIsShowGridChecked(true);   // Hide grid
  setIsSnapToGridChecked(true); // Disable snap to grid

  // Optionally reset tab or multipleQR toggle if needed
  setActiveTab('label');
  setMultipleQR(false);
  
};


  return (
    <>
      <h5 className="text-light mb-3">Settings</h5>
      <div className="p-3 border rounded bg-light">
        <Tabs activeKey={activeTab} onChange={setActiveTab} centered>
          {/* Label Tab */}
          <TabPane tab="Label" key="label">
            <Form>
              {/* <Form.Group className="d-flex align-items-center mb-3 p-2 rounded bg-light border">
                <Form.Label className="text-dark w-25 m-0 px-3 py-2 bg-secondary-subtle text-center rounded-start">
                  Width
                </Form.Label>
                <div className="d-flex w-75 bg-white rounded px-2 align-items-center">
                  <FormControl type="number" defaultValue="2.625" className="border-0 text-center bg-white py-2" />
                  <InputGroup.Text className="bg-secondary-subtle border-0 px-3 py-2 rounded-end">
                    inches
                  </InputGroup.Text>
                </div>
              </Form.Group> */}
            <Form.Group className="d-flex align-items-center mb-3 p-2 rounded bg-light border">
              <Form.Label className="text-dark w-25 m-0 px-3 py-2 bg-secondary-subtle text-center rounded-start">
                Width
              </Form.Label>
              <div className="d-flex w-75 bg-white rounded px-2 align-items-center">
                <FormControl
                  type="number"
                  min="0" // 🛑 Prevent negative values in input
                  placeholder="3"
                  value={widthInInches} // Controlled input
                  onChange={(e) => setWidthInInches(parseFloat(e.target.value) || 0)} // Update state
                  className="border-0 text-center bg-white py-2"
                />
                <InputGroup.Text className="bg-secondary-subtle border-0 px-3 py-2 rounded-end">
                  inches
                </InputGroup.Text>
              </div>
            </Form.Group>

              <Form.Group className="d-flex align-items-center mb-3 p-2 rounded bg-light border">
                <Form.Label className="text-dark w-25 m-0 px-3 py-2 bg-secondary-subtle text-center rounded-start">
                  Height
                </Form.Label>
                <div className="d-flex w-75 bg-white rounded px-2 align-items-center">
                  <FormControl 
                  type="number"
                  min="0" // 🛑 Prevent negative values in input
                  placeholder="2"
                  value={heightInInches } // Controlled input
                  onChange={(e) => setHeightInInche(parseFloat(e.target.value) || 0)} // Update state
                  className="border-0 text-center bg-white py-2"
                  />
                  <InputGroup.Text className="bg-secondary-subtle border-0 px-3 py-2 rounded-end">
                    inches
                  </InputGroup.Text>
                </div>
              </Form.Group>

              <Form.Label className="mt-3 text-dark">ORIENTATION</Form.Label>
              <Row className="mb-3 text-center">
                <Col>
                  <ButtonGroup className="w-100 border rounded-1">
                  <Button variant="outline-secondary" size="sm" className="w-100 border-0"
                       onClick={() => handleSaveAsPDF && handleSaveAsPDF()} // ✅ Call the function on click
                       >
                        <FaDownload />
                      </Button>
                    {/* <Button variant="outline-secondary" size="sm" className="w-100 border-0"><FaUndo /></Button> */}
                    {/* <Button variant="outline-secondary" size="sm" className="w-100 border-0"><BiShuffle size={20} /></Button> */}
                    <Button variant="outline-secondary" size="sm" className="w-100 border-0" onClick={handleClearButtonClick} ><GiBroom size={20} /></Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Form.Label className='text-dark'>STYLE</Form.Label>
              <Row>
                <Col>
                  <Dropdown overlay={colorMenu} trigger={["hover"]}>
                    <Button className="w-100">Color ▼</Button>
                  </Dropdown>
                </Col>
                {/* <Col>
                  <Dropdown overlay={shapeMenu} trigger={["hover"]}>
                    <Button className="w-100">Shape ▼</Button>
                  </Dropdown>
                </Col> */}
              </Row>

              <Form.Label className="mt-3 text-dark">ASSIST</Form.Label>
              <Form.Check
                className="text-dark"
                type="checkbox"
                label="Ruler"
                checked={isRulerChecked}
                onChange={() => setIsRulerChecked((prev) => !prev)}// Optional: allows manual toggling
              />
              <Form.Check
                className="text-dark"
                type="checkbox"
                label="Show Grid"
                checked={isShowGridChecked}
                onChange={() => setIsShowGridChecked((prev) => !prev)} // Optional: allows manual toggling
              />
              <Form.Check
                className="text-dark"
                type="checkbox"
                label="Snap to Grid"
                checked={isSnapToGridChecked}
                onChange={() => setIsSnapToGridChecked((prev) => !prev)}// Optional: allows manual toggling
              />

             
            </Form>
          </TabPane>

          {/* Design Tab */}
          <TabPane tab="Design" key="design">
            <Form>
              <Form.Group>
                <ButtonGroup className="w-100 mb-2 rounded-0 border-1 border-dark">
                  <Button variant="outline-primary" className="w-50 rounded-0 border-0" onClick={handleTextButtonClick}>Text</Button>
                  <Button variant="outline-primary" className="w-50 rounded-0 border-0" onClick={handleImageButtonClick}>Select Image</Button>
                  <Select
                  defaultValue={null}
                  placeholder="Select"
                  className="w-100 rounded-0"
                  style={{ border: 'none', boxShadow: 'none' }}
                  onChange={(value) => onCodeTypeChange(value)}
                >
                  <Select.Option value="barcode">Barcode</Select.Option>
                  <Select.Option value="upc">UPC</Select.Option>
                </Select>
                </ButtonGroup>
                {/* Show file input when isImageClicked is true */}
                {/* Show file input when isImageClicked is true */}
                {isImageClicked && (
                  <div style={{ marginTop: "10px" }}>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                )}
              </Form.Group>
              {/* <Row className="mt-3 text-center">
                <Col><Button variant="outline-secondary" size="sm"><FaUndo /> Undo</Button></Col>
                <Col><Button variant="outline-secondary" size="sm" disabled><FaRedo /> Redo</Button></Col>
              </Row> */}
              <Form.Label className="mt-3 text-dark">OBJECTS</Form.Label>
              <div className="border rounded p-2 bg-white">
                {/* <Badge bg="primary" className="text-white px-2 py-1" style={{ fontSize: 'inherit' }}>Text</Badge> */}
                {/* <FormControl className="mt-2" defaultValue="TEKaLabel" /> */}
                <InputGroup className="mt-2">
                  <FormControl
                    type="number"
                    value={fontSize}
                    className="border rounded-start"
                    style={{ borderRight: "none", textAlign: "right" }}
                    onChange={(e) => setFontSize(Number(e.target.value))} // Update font size
                  />
                  <InputGroup.Text
                    className="border rounded-end"
                    style={{ borderLeft: "none", backgroundColor: "white" }}
                  >
                    pt
                  </InputGroup.Text>
                </InputGroup>
                <div className="mt-2">
                <Button variant="outline-secondary" onClick={() => updateTextFormatting({ fontWeight: "bold" })}>
                    <FaBold />
                </Button>
                <Button variant="outline-secondary" onClick={() => updateTextFormatting({ fontStyle: "italic" })}>
                    <FaItalic />
                </Button>
                <Button variant="outline-secondary" onClick={() => updateTextFormatting({ textDecoration: "underline" })}>
                    <FaUnderline />
                </Button>

                <Button variant="outline-danger" onClick={() => setEditingId(null)}>
                  <FaTimes color='red' />
                </Button>

                </div>
              </div>
            </Form>
          </TabPane>

          {/* Data Tab */}
          <TabPane tab="Data" key="data">
            <Form>
            <Form.Group className="mb-3">
            <Form.Label className="text-dark">Link :</Form.Label>
            <FormControl
              type="text"
              placeholder=""
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </Form.Group>

              <Form.Group className="mb-3 d-flex align-items-center">
              <Form.Label className="text-dark" style={{ width: '40%' }}>Multiple QR :</Form.Label>
              <div style={{ width: '60%', display: 'flex', justifyContent: 'flex-start' }}>
                <Switch
                  checked={multipleQR}
                  onChange={(checked) => setMultipleQR(checked)}
                  style={{ backgroundColor: multipleQR ? '#000' : '#ccc' }}
                />
              </div>
            </Form.Group>

            {/* Conditionally show QR Start & End only when multipleQR is checked */}
            {multipleQR && (
              <>
                <Form.Group className="mb-3">
                  <Form.Label className="text-dark">QR Start :</Form.Label>
                  <FormControl type="text" placeholder="Enter start value" />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label className="text-dark">QR End :</Form.Label>
                  <FormControl type="text" placeholder="Enter end value" />
                </Form.Group>
              </>
            )}

            </Form>
          </TabPane>

          {/* Print Tab */}
          <TabPane tab="Print" key="print">
            <Form>
              <div className="mb-3 d-flex gap-2">
                <Button variant="outline-primary" size="sm" className="w-auto">
                  <span style={{ fontSize: '1.2rem' }}>🖨️</span>
                </Button>
                <Button variant="outline-primary" className="w-100"
                onClick={() => handleSaveAsPDF && handleSaveAsPDF()} // ✅ Call the function on click
                >
                  Print Preview
                </Button>
              </div>

              <div className="mb-3 d-flex gap-2">
                <div xs={2} className="d-flex gap-2 justify-content-center align-items-center">
                  <Button variant="outline-warning" size="sm" className="w-auto">
                    <span style={{ fontSize: '1.2rem' }}>ℹ️</span>
                  </Button>
                  <Form.Label className="text-dark mb-0" style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Label Copies</Form.Label>
                </div>
                <div className="d-flex justify-content-between align-items-center">

                  <FormControl
                    type="number"
                    value={labelCopies}
                    onChange={(e) => setLabelCopies(Math.max(1, parseInt(e.target.value) || 1))}
                    className="text-center w-100"
                  />
                  {/* <div className="w-100 count-box">
                  <Button variant="outline-secondary" onClick={handleDecrement} style={{ flex: '0 0 30%' }}>
                    <FaMinus />
                  </Button>
                  <Button variant="outline-secondary" onClick={handleIncrement} style={{ flex: '0 0 30%' }}>
                    <FaPlus />
                  </Button>
                </div> */}
                </div>
              </div>

              <Row className="mb-3">
                <Col>
                  <Button variant="primary" className="w-100">
                    Print
                  </Button>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Button variant="success" className="w-100">
                    Save & Print
                  </Button>
                </Col>
              </Row>
            </Form>
          </TabPane>
        </Tabs>

        {/* Shared Footer Buttons in a Single Line */}
        <Row className="mt-3 d-flex align-items-center justify-content-between">
          <Col xs="auto" className="text-center">
            <Button variant="outline-secondary" size="sm" onClick={() => handleTabChange('back')}>
              <FaArrowLeft /> Go Back
            </Button>
          </Col>
          <Col xs="auto" className="text-center">
            <Button variant="warning" className="w-100" onClick={() => handleTabChange('next')}>
              {getSaveButtonText()} <FaArrowRight />
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default SettingsPanel;